import {DeepLinkActionBase} from '../deep-link-action-base';
import {
  IOpenMyAccountOptions
} from "../../../external-links/handlers/my-account/my-account.external-link-handler.interface";
import {Check} from "@sparkware/app-utils";

export class MyAccountDeepLinkAction extends DeepLinkActionBase {
  async execute(): Promise<void> {
    let tabId = this.descriptor.actionParams && parseInt(this.descriptor.actionParams.id);
    let options: IOpenMyAccountOptions | undefined = undefined;
    if(Check.isNumber(tabId)) {
      options = {
        tabId: tabId
      };
    }
    await this.services.externalLinks.openMyAccount(options);
  }

}
